import { Box, IconButton, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useFetchMonthlyReportsQuery } from "../../slice/logdetailSlice";
import { format, parse, startOfMonth } from "date-fns";
import { CiExport } from "react-icons/ci";
import MonthCalendar from "./MonthCalendar";
import { useEffect, useState } from "react";
import SearchBar, { useDebounce } from "../../components/SearchBar";
import { CustomNoRowsOverlay } from "../../components/common/OverlayGrid";
import { createEntity } from "../../apis/apiService";
import { toast } from "react-toastify";
import { endOfMonth } from "date-fns";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../ThemeContext";

const ExportCommonTimesheet = () => {
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
    selectedMonth: format(new Date(), "yyyy-MM"),
  });
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const {
    data: monthly_reports = [],
    isLoading: reports_loading,
    refetch: monthly_reports_refetch,
  } = useFetchMonthlyReportsQuery({
    date: selectionRange.selectedMonth,
    search: debouncedSearchTerm,
  });
  const indexedRows = monthly_reports.map((row, index) => ({
    ...row,
    serial_id: index + 1,
  }));
  const handleSearchChange = async (event) => {
    const value = event.target.value;
    const trimmedValue = value.trim();
    setSearchTerm(trimmedValue);
  };

  useEffect(() => {
    monthly_reports_refetch();
  }, []);

  const handleIconClick = async (row) => {
    setLoading(true);
    const selectedMonthDate = parse(
      selectionRange.selectedMonth,
      "yyyy-MM",
      new Date()
    );
    // console.log("Row Data:", row);
    const requestedData = {
      project_id: row.project_id,
      //   date: selectionRange.selectedMonth.startOf("month").format("YYYY-MM-DD"),
      group_by: "users",
      format: "excel",
      export_mode: "default",
      start_date: format(startOfMonth(selectedMonthDate), "yyyy-MM-dd"),
      end_date: format(endOfMonth(selectedMonthDate), "yyyy-MM-dd"),
    };

    try {
      const response = await createEntity("timesheet/export", requestedData);
      if (response?.doc_url) {
        toast.success(response.message);

        // Trigger the download
        const link = document.createElement("a");
        link.href = response.doc_url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      field: "serial_id",
      headerName: "ID",
      width: 100,
    },
    {
      field: "project_id",
      headerName: "Project ID",
      width: 150,
    },
    {
      field: "project_name",
      headerName: "Project Name",
      flex: 1,
      minWidth: 300,
      renderCell: (params) => {
        const { row } = params;
        // console.log("params_value_reports :", row);
        // /projects/projectDetail/209/details
        let project_id = row.project_id;
        return (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="flex-start"
            height="100%"
            onClick={() =>
              navigate(`/projects/projectDetail/${project_id}/details`)
            }
          >
            <Typography>{row.project_name}</Typography>
          </Box>
        );
      },
    },
    {
      field: "total_hours",
      headerName: "Work Hours",
      width: 150,
    },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          disabled={loading}
          onClick={() => handleIconClick(params.row)}
        >
          <CiExport className="text-rgbr-blue pro-icon-s" />
        </IconButton>
      ),
    },
  ];

  const { isDarkMode } = useTheme();

  return (
    <div className="bg-white p-3">
      {/* <div className="d-flex align-items-center justify-content-between gap-3"> */}
      <Box
        className="d-flex align-items-center justify-content-between gap-3"
        sx={{
          border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
          borderRadius: "6px",
          padding: "12px 16px",
          marginBottom: "16px",
          backgroundColor: isDarkMode ? "transparent" : "#fff",
        }}
      >
        <div>{/* Left button */}</div>

        <div className="mx-auto">
          <MonthCalendar
            selectionRange={selectionRange}
            setSelectionRange={setSelectionRange}
          />
        </div>

        <div className="">
          <SearchBar
            placeholder="Search Project"
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
          />
        </div>
      {/* </div> */}
        </Box>

      <div className="my-3">
        <DataGrid
          rows={indexedRows}
          columns={columns}
          loading={reports_loading}
          autoHeight
          disableColumnReorder
          getRowId={(row) => row.project_id}
          slots={{ noRowsOverlay: CustomNoRowsOverlay }}
        />
      </div>
    </div>
  );
};

export default ExportCommonTimesheet;
